// 判断是否为开发环境
export const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

// 判断是否启用Mock
export const isMockEnabled = !!import.meta.env.VITE_MOCK;

// 判断是否为生产环境
export const isProduction = import.meta.env.PROD || process.env.NODE_ENV === 'production';


export const G_EmptyStr = '-';

export const PluginIDHashMap: any = {
  // MI - HE 插件 替换
  // 剪映小助手
  '7522412867740565513': '7622200883564150819',

  
  // SU - TUI 插件 替换
  // 剪映小助手数据生成器
  '7475829177439109155': '7622200883564150819',
  // 视频合成_剪映小助手
  '7457837925833801768': '7622200883564150819',
};
